module.exports = __webpack_public_path__ + "img/lock.8e4da1fa.svg";